import { useState, useEffect } from "react";
import { getCompanyData } from "../utils/generalUtil";
import {
  getCompanySubscription,
  SubscriptionInfo,
} from "../api/SubscriptionAPI";

export const useSubscriptionExpired = () => {
  const [isExpired, setIsExpired] = useState(false);
  const [subscriptionInfo, setSubscriptionInfo] =
    useState<SubscriptionInfo | null>(null);
  const [loading, setLoading] = useState(true);

  const checkSubscription = async () => {
    try {
      setLoading(true);

      const companyData = getCompanyData();
      const companyId = companyData?.companyId;

      if (!companyId) {
        setIsExpired(false);
        setLoading(false);
        return;
      }

      const info = await getCompanySubscription(Number(companyId));
      setSubscriptionInfo(info);
      if (!info || !info.subscription) {
        setIsExpired(false);
        setLoading(false);
        return;
      }

      const subscription = info.subscription;
      const now = new Date();
      let expired = false;

      switch (subscription.status) {
        case 2:
        case 3:
          expired = true;
          break;

        case 0:
          if (subscription.trialEndsAt) {
            const trialEnd = new Date(subscription.trialEndsAt);
            expired = now > trialEnd;
          }
          break;

        case 1:
          if (subscription.currentPeriodEndsAt) {
            const periodEnd = new Date(subscription.currentPeriodEndsAt);
            expired = now > periodEnd;
          }
          break;
      }

      setIsExpired(expired);
    } catch (error) {
      console.error("Erro ao verificar assinatura:", error);
      setIsExpired(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSubscription();
  }, []);

  return {
    isExpired,
    subscriptionInfo,
    loading,
    refresh: checkSubscription,
  };
};
